import React, { Component } from 'react'

class ListModal extends Component {

    render() {
        const { IdModal, HeaderTitle, Body, CloseActions, Footer } = this.props
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open" role="dialog" id={IdModal} >
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">
                            <div className="modal-body" >
                            <h4 className="modal-title mb-2" id="modal-basic-title ">{HeaderTitle}</h4>
                                {Body}
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={CloseActions} className="btn btn-secondary" >Cerrar</button>
                                {!!Footer && Footer}
                                {/* <button type="button" onClick={()=> DoAction} className="btn botonCorrect" >{DoActionMsj ?? ''}</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ListModal